<template>
  <header id="site-header" class="site-header" :class="{ 'open' : isOpen, home: isHome }">
    <div class="content-max-width wrap flex align-center">
      <a href="/home" class="logo">
        <img src="/images/logo.png" alt="Website Logo" />
      </a>

      <nav>
        <ul class="top">
          <li class="mobile">
            <a href="/home">Home</a>
          </li>
          <li
            v-for="(link, index) of menu"
            :key="index"
            :class="{ active: link.url == currentPath }"
          >
            <a :href="link.url">{{ link.title }}</a>
          </li>
          <a href="#" class="button white-border mobile" @click="showingQuoteModal = true">
            Get A Quote
          </a>
        </ul>
      </nav>

      <a href="#" class="button white-border desktop" @click="showingQuoteModal = true">
        Get A Quote
      </a>

      <button class="hamburger mobile" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <QuoteRequestModal
        v-if="showingQuoteModal"
        @close="showingQuoteModal = false"
        class="quote-modal"
        :request_id="request_id"
    />
  </header>
</template>

<script>
import QuoteRequestModal from '@/components/Popups/QuoteRequest'

export default {
  components: { QuoteRequestModal },

  props: {
    request_id : Number,
    menu : Array,
    csrf : String
  },

  data () {
    return {
      isOpen: false,
      showingQuoteModal: false,
    }
  },

  computed: {
    isHome () {
      return ['/', '/home', '/home'].includes(window.location.pathname)
    },

    currentPath () {
      return window.location.pathname
    },
  },

  methods: {
    toggleMenu () {
      this.isOpen = !this.isOpen
    }
  },
};
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Header.vue